"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./Pivot"));
var PivotItem_1 = require("./PivotItem");
exports.PivotItem = PivotItem_1.PivotItem;
__export(require("./Pivot.Props"));

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Pivot/index.js
// module id = 242
// module chunks = 0